<!-- Global component for messages -->
<template>
  <div ref="el" class="message-component message">
    <svg-icon v-if="showIcon" :name="iconName" kind="indicative" />
    <span>
      <slot />
    </span>
  </div>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, useTemplateRef } from "vue";

// Data
const iconName = ref("");

// Template refs
const el = useTemplateRef<HTMLElement>("el");

// Computed
const showIcon = computed(() => {
  return iconName.value !== "";
});

// Methods
const checkIconName = (element) => {
  const messageClass = element.className;
  if (messageClass.includes("error")) {
    iconName.value = "Error16";
  } else if (messageClass.includes("info")) {
    iconName.value = "Info16";
  } else if (messageClass.includes("success")) {
    iconName.value = "Success16";
  } else if (messageClass.includes("warning")) {
    iconName.value = "Warning16";
  } else {
    iconName.value = "";
  }
};

// Mounted
onMounted(() => {
  checkIconName(el.value);
});
</script>

<style lang="scss">
@import "@styles/themes/sls-theme/tokens/colors";
@import "@styles/themes/sls-theme/tokens/spacing";
@import "@styles/themes/sls-theme/tokens/typo";

.message-component {
  display: flex;
  align-items: center;
  margin: $spacing-02 0;

  * {
    @include carbon--type-style("helper-text-01", true);
  }

  > .sls-icon {
    min-width: 16px;
    min-height: 16px;
    margin-right: $spacing-02;
    margin-bottom: auto;
  }

  &.error {
    color: $support-01;

    span {
      word-break: normal;
    }
  }

  &.success {
    color: $support-02;
  }

  &.warning {
    color: $support-03;
  }

  &.info {
    color: $support-04;
  }
}
</style>
